import React from 'react'

export const Price = ({ value = 0 }) => {
  const formatPrice = (price) => {
    return price.toLocaleString('en-US');
  };

  return <span>$ {formatPrice(value)}</span>;

}